module.exports = __webpack_public_path__ + "static/media/mastercard.a5aec975.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/TransactionsTable/images/mastercard.svg
// module id = 654
// module chunks = 0